module.exports = __webpack_public_path__ + "static/media/Step4_PagamentosRecebimentos.8cc832ee.png";